import { Directive, Input, HostBinding } from '@angular/core';

export type InputValueAlignment = 'left' | 'center' | 'right';

@Directive({
  selector: 'input[i2gInput],textarea[i2gInput]',
})
export class InputDirective {
  @Input() valueAlignment: InputValueAlignment = 'left';

  @HostBinding('class.value-alignment-center')
  get valueAlignmentCenter() {
    return this.valueAlignment === 'center';
  }

  @HostBinding('class.value-alignment-right')
  get valueAlignmentRight() {
    return this.valueAlignment === 'right';
  }
}
